import http from '@admin/http';
import { AxiosInstance } from 'axios';

export function unblockAccountCtor(http: AxiosInstance) {
  return async (id: string) => http.put(`/lnpl/v1/delinquent-loan-orders/${id}/unblock-account`);
}

export const unblockAccount = unblockAccountCtor(http);
